import {combineReducers} from 'redux';
// import { IntlReducer as Intl } from 'react-redux-multilingual';
import agentConfig from './getAgentConfig';
import incomingCalls from './incomingCalls';
import outgoingCalls from './outgoingCalls';
import queuedCalls from './queuedCalls';
import autoDialerCalls from './autoDialerCalls';
import callForward from './callForward';
import agentInfo from './agentInfo';
import globalLoading from './globalLoading';
import businessOutcome from './businessOutcome';
import tagsList from './tags';
import servicesList from './outgoingService';
import availability from './availability';
import languages from './language';
import callEvents from './callEvents';
import agentsAndSupervisors from './agentsAndSupervisors';
import addressBook from './addressBook';
import runtime from './runtime';
import logout from './logout';
import common from './common';
import browserTabs from './browserTabs';
import incomingCallsList from './incomingCallsList';

const allReducers = combineReducers({
     agentConfig,
     incomingCalls,
     outgoingCalls,
     queuedCalls,
     autoDialerCalls,
     callForward,
     agentInfo,     
     globalLoading,
     businessOutcome,
     tagsList,
     servicesList,
     availability,
     languages,
     callEvents,
     agentsAndSupervisors,
     addressBook,
     runtime,
     logout,
     common,
     browserTabs,
     incomingCallsList
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js